import React, { useState } from 'react'
import { Icon } from '@guillotinaweb/react-gmi'

import './accordion-card.css'

/**
 * This component is to dropdown content inside a card:
 *
 * ***************
 * * Title     v *
 * ***************
 *
 * And on click to the caret icon:
 *
 * ***************
 * * Title     ^ *  -> props.title
 * ***************
 * * Some        *
 * * Content     *  -> props.children
 * ***************
 *
 */
export function AccordionCard({
  children,
  className = '',
  defaultCollapsed = true,
  renderCollapsed = true,
  onToggle,
  title,
  ...props
}) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed)
  const toggle = () => setCollapsed((v) => !v)
  const iconPosition = collapsed ? 'down' : 'up'

  return (
    <div {...props} className={`accordion-card ${className}`}>
      <header>
        {title}
        <button
          type="button"
          onClick={() => {
            if (onToggle) onToggle(!collapsed)
            toggle()
          }}
          className="collapse"
        >
          <Icon key={iconPosition} icon={`fas fa-angle-${iconPosition}`} />
        </button>
      </header>
      {/* We want to render the children always (even when is collapsed) because otherwise
       form validation doesn't work */}
      {(!collapsed || renderCollapsed) && (
        <div className="content" style={{ display: collapsed ? 'none' : '' }}>
          {children}
        </div>
      )}
    </div>
  )
}
